// The gated serving path a stored photo id resolves to (matches
// backend/internal/http/photo.go's own photoURL helper exactly).
// GET /me/profile's response already returns this same shape in its
// own `photos` field -- see photoIdFromPath below for why callers
// still need to convert back and forth between the two forms.
export function photoPath(id: string): string {
  return `/photos/${id}`;
}

// The inverse of photoPath/photoURL. PATCH /me/profile has no
// partial-merge semantics: every call sends the full desired state,
// and its `photos` field is the RAW STORED IDS (see
// backend/internal/http/profile.go's UpdateProfileHandler, which
// writes body.Photos straight into the Profile with no transform) --
// but GET/PATCH's own RESPONSE shape maps those same ids through
// toPhotoURLs into "/photos/{id}" paths before sending them back. A
// naive round-trip (read the response, PATCH it back unchanged) would
// therefore store the literal string "/photos/{id}" as a photo id,
// breaking every future GET (double-prefixed to "/photos//photos/xyz")
// -- this strip is what makes that round-trip safe. Discovered while
// wiring profile/index.tsx's own prefill, not by a bug report --
// worth being explicit about since nothing failed loudly to reveal it.
// Extracted here (issue #80's profile-photos split) so both
// profile/index.tsx and profile-photos/index.tsx share exactly one
// implementation instead of two copies drifting apart.
export function photoIdFromPath(path: string): string {
  return path.replace(/^\/photos\//, '');
}

// The downscaled variant of a stored photo path (issue #414): what feed
// cards and grids show, so they do not download the full-size original.
// Same access rule as the original; the lightbox still opens the full path.
// Only paths under /photos/ have a variant.
export function thumbnailPath(path: string): string {
  return path.startsWith('/photos/') && !path.includes('?') ? `${path}?w=640` : path;
}
